require('./RAMessage.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

const RAMessage = ({ children, title }) => {
    return (
        <div className="ra-message">
            <p className="ra-message__title">{title}</p>
            <div className="ra-message__text">{children}</div>
        </div>
    );
};

RAMessage.propTypes = {
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

module.exports = RAMessage;
